import apiClient from '../api/client';

/**
 * Read-only reference data for the boom lifts: specifications, alarm
 * thresholds, fault codes, service checklists.
 *
 * `getMachineThresholds` is the per-machine view — every threshold's safe
 * operating band with THAT machine's latest reading already judged against it
 * by the same code the alarm engine runs (services/machineHealthChecker), so
 * the screen and the alarms can never disagree about what "out of range" means.
 */
const equipmentSpecsService = {
    /** Alarm operating ranges for the fleet (model-independent bands). */
    async getThresholds() {
        return await apiClient.get('/equipment-specs/thresholds');
    },

    /**
     * Operating bands + live readings for one machine.
     * @param {string} equipmentId equipment id (or tracker id) from the URL.
     * @returns {Promise<{data: Array, meta: Object}>}
     */
    async getMachineThresholds(equipmentId) {
        return await apiClient.get(`/equipment-specs/machine/${encodeURIComponent(equipmentId)}/thresholds`);
    },

    /** OEM SPN/FMI fault-code dictionary. */
    async getFaultCodes(params = {}) {
        return await apiClient.get('/equipment-specs/fault-codes', { params });
    },
};

export default equipmentSpecsService;
